import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ADMIN_CODE = "0913";
const STORAGE_KEY = "caprio_admin_unlocked";

const AdminContext = createContext({
    isAdmin: false,
    unlock: () => false,
    lock: () => {},
    gateOpen: false,
    setGateOpen: () => {},
});

export function AdminProvider({ children }) {
    const [isAdmin, setIsAdmin] = useState(() => {
        try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch (_) { return false; }
    });
    const [gateOpen, setGateOpen] = useState(false);

    useEffect(() => {
        try {
            if (isAdmin) localStorage.setItem(STORAGE_KEY, "1");
            else localStorage.removeItem(STORAGE_KEY);
        } catch (_) {}
    }, [isAdmin]);

    const unlock = useCallback((code) => {
        if (String(code).trim() === ADMIN_CODE) {
            setIsAdmin(true);
            return true;
        }
        return false;
    }, []);

    const lock = useCallback(() => setIsAdmin(false), []);

    return (
        <AdminContext.Provider value={{ isAdmin, unlock, lock, gateOpen, setGateOpen }}>
            {children}
        </AdminContext.Provider>
    );
}

export function useAdmin() {
    return useContext(AdminContext);
}
